import ConfigInputContainer from "../../../../common/components/ConfigInputContainer";
import { IConductedStoryGameConfig } from "../../../../common/types";
import React, { ChangeEvent, Dispatch, SetStateAction } from "react";
import ConfigScreen from "../../../../common/components/game-screens/ConfigScreen";
import { ConfigSwitch } from "../../../../common/components/config-switch/ConfigSwitch";
import { Input } from "antd";
import { useTranslation } from "react-i18next";

interface Props{
    moveBack: () => void;
    moveForward: () => void;
    config: IConductedStoryGameConfig;
    changeConfig: Dispatch<SetStateAction<IConductedStoryGameConfig>>;
}
const ConductedStoryGameSettings = ({ moveBack, moveForward, config, changeConfig}: Props) => {
   
    const { t } = useTranslation();

    const handleStateChange = (property: string) => (value: any) => {
        changeConfig((prevConfig) => ({
          ...prevConfig,
          [property]: value,
        }));
    };

    const handleInputChange = (property:string) => (event: ChangeEvent<HTMLInputElement>):void => {
      handleStateChange(property)(event.target.value);
    };
      
    const placeholderText = t("games.conducted-story.settings.placeholders-name") as string;
    
    return (
        <ConfigScreen
        configTitlePath="games.conducted-story.settings.title"
        backToDetails={moveBack}
        nextButtonLabelPath="games.buttons.play"
        nextToPlay={moveForward}
        nextActionDisabled={!config.randomTopic && config.customTopic === ""}>
            <ConfigInputContainer labelPath="games.conducted-story.settings.random-topic">
                <ConfigSwitch
                    onChange={handleStateChange("randomTopic")}
                    checked={config.randomTopic}/>
            </ConfigInputContainer>
            {!config.randomTopic && (
              <ConfigInputContainer>
                <Input
                    placeholder={placeholderText}
                    bordered={false}
                    value={config.customTopic}
                    onChange={handleInputChange("customTopic")}
                />
              </ConfigInputContainer>
            )}
        </ConfigScreen>
    );
};

export default ConductedStoryGameSettings;